import { stringifySearchWith } from "@tanstack/react-router";

function parseSearchValue(value: string): unknown {
  const firstCharacter = value.trimStart()[0];
  if (firstCharacter !== "{" && firstCharacter !== "[") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

/**
 * URL query parameters are strings by default. Only explicitly serialized
 * objects and arrays are JSON-parsed, so values such as "123", "true", and
 * "null" do not silently change type after navigation or page reload.
 */
export function parseSearch(searchString: string): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  const searchParams = new URLSearchParams(searchString);

  for (const [key, rawValue] of searchParams) {
    const value = parseSearchValue(rawValue);
    const previousValue = result[key];

    if (previousValue === undefined) {
      result[key] = value;
    } else if (Array.isArray(previousValue)) {
      previousValue.push(value);
    } else {
      result[key] = [previousValue, value];
    }
  }

  return result;
}

export const stringifySearch = stringifySearchWith(JSON.stringify);
